import * as React from 'react';
import ConfirmBoxButton from '../ConfirmBoxButton';

const RejectActivityReason = ({ header, message, confirmationText, onConfirmClick, onCancelClick }) => {
    const [reason, setReason] = React.useState('');

    const handleChange = (e) => {
        setReason(e.target.value);
    };

    const handleConfirmClick = () => {
        const trimmedReason = reason.trim();
        if (!trimmedReason) {
            return;
        }
        onConfirmClick(trimmedReason);
    };

    return (
        <React.Fragment>
            {header && (
                <div className="modalHeader">
                    <h1>{header}</h1>
                </div>
            )}
            <div className="modalBody">
                {message && (
                    <div className="alignMiddle rowSpaceBetween modalHeading">{message}</div>
                )}
                <div className="formGroup mt">
                    <textarea
                        value={reason}
                        onChange={handleChange}
                        placeholder="Please provide a reason for rejecting this activity."
                    />
                </div>
            </div>
            <ConfirmBoxButton
                onCancelClick={onCancelClick}
                onConfirmClick={handleConfirmClick}
                confirmText={confirmationText || 'Reject'}
                confirmDisabled={!reason.trim()}
                cancelText="Cancel"
                middleText=""
            />
        </React.Fragment>
    );
};

export default RejectActivityReason;
